import federacionpatronal from "../Assets/img/logos/cias/logo_federacionpatronal_b.png"
import liberty from "../Assets/img/logos/cias/logo_liberty_b.png"
import rsa from "../Assets/img/logos/cias/logo_rsa_b.png"
import allianz from "../Assets/img/logos/cias/logo_allianz.svg"
import experta from "../Assets/img/logos/cias/logo_experta.svg"
import sancristobal from "../Assets/img/logos/cias/logo_sancristobal.svg"
import zurich from "../Assets/img/logos/cias/logo_zurich.svg"
import mercantil from "../Assets/img/logos/cias/logo_mercantil.svg"
import meridional from "../Assets/img/logos/cias/logo_meridional.svg"
import provincia from "../Assets/img/logos/cias/logo_provinciaseguros.svg"
import galeno from "../Assets/img/logos/cias/logo_galeno.svg"
import sancor from "../Assets/img/logos/cias/logo_sancor.svg"
import libra from "../Assets/img/logos/cias/logo_libra.svg"
import mapfre from "../Assets/img/logos/cias/logo_mapfre.svg"
import smg from "../Assets/img/logos/cias/logo_SMG.svg"
import orbis from "../Assets/img/logos/cias/logo_orbis.svg"
import nowAssistance from "../Assets/img/logos/cias/logo_nowassistance.svg"
import rivadavia from "../Assets/img/logos/cias/logo_rivadavia.svg"
import bse from "../Assets/img/logos/cias/logo_bse_b.svg"
import hdi from "../Assets/img/logos/cias/logo_barbuss.svg"
import porto from "../Assets/img/logos/cias/Logo Porto Seguros.svg"
import sura from "../Assets/img/logos/cias/logo_sura_b.png"
import { PaisType } from "../Pages/Landings/diccionario"

export interface Companias {
    nombreCompania: string,
    imgRuta: string,
    mostrar: boolean,
    imgRutaUy?: string,
    pais?: PaisType[]
}

export const imagesCompanias: Companias[] = [
    {
        nombreCompania: "rsa",
        imgRuta: rsa,
        imgRutaUy: sura,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "smg",
        imgRuta: smg,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "libra",
        imgRuta: libra,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "liberty",
        imgRuta: liberty,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "galeno",
        imgRuta: galeno,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "federacionpatronal",
        imgRuta: federacionpatronal,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "allianz",
        imgRuta: allianz,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "experta",
        imgRuta: experta,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "sancristobal",
        imgRuta: sancristobal,
        mostrar: true,
        pais: ["AR", "UY"]
    },
    {
        nombreCompania: "mercantil",
        imgRuta: mercantil,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "rivadavia",
        imgRuta: rivadavia,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "provinciaseguros",
        imgRuta: provincia,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "sancor",
        imgRuta: sancor,
        mostrar: true,
        pais: ["AR", "UY"]
    },
    {
        nombreCompania: "now",
        imgRuta: nowAssistance,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "zurich",
        imgRuta: zurich,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "mapfre",
        imgRuta: mapfre,
        mostrar: true,
        pais: ["AR", "UY"]
    },
    {
        nombreCompania: "orbis",
        imgRuta: orbis,
        mostrar: false,
        pais: ["AR"]
    },
    {
        nombreCompania: "meridional",
        imgRuta: meridional,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "bse",
        imgRuta: bse,
        mostrar: true,
        pais: ["UY"]
    },
    {
        nombreCompania: "sura",
        imgRuta: sura,
        mostrar: true,
        pais: ["UY"]
    },
    {
        nombreCompania: "porto",
        imgRuta: porto,
        mostrar: true,
        pais: ["UY"]
    },
    {
        nombreCompania: "hdi",
        imgRuta: hdi,
        mostrar: true,
        pais: ["UY"]
    },

]

export const imagenesCompaniasFiltradas = (companiasDisponibles: any): Companias[] => {
    return companiasDisponibles.map((compania: any) => {
        const imagen = imagesCompanias.find(image =>
            image.nombreCompania.toLowerCase() === compania.codigoCompania.toLowerCase()
        );

        return {
            ...compania,
            imgRuta: imagen ? imagen.imgRuta : null,
            mostrar: imagen ? true : false
        };
    })
}
